﻿package com.mgacreative.hotelru.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.domain.model.PosCategory
import com.mgacreative.hotelru.domain.model.PosItem
import com.mgacreative.hotelru.domain.repository.PosRepository
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

class AdminMenuViewModel(
    private val posRepository: PosRepository
) : ViewModel() {

    val categories: StateFlow<List<PosCategory>> = posRepository.observeCategories()
        .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), emptyList())

    val items: StateFlow<List<PosItem>> = posRepository.observeItems()
        .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), emptyList())

    init {
        loadData()
    }

    fun loadData() {
        viewModelScope.launch {
            posRepository.loadMenu()
            ensureDefaultCategories()
        }
    }

    private suspend fun ensureDefaultCategories() {
        val existingNames = categories.value.map { it.name.lowercase() }
        val defaultCategories = listOf("Food", "Beverages", "Desserts", "Alcohol", "Other")
        
        defaultCategories.forEach { defaultCat ->
            if (!existingNames.contains(defaultCat.lowercase())) {
                posRepository.saveCategory(defaultCat)
            }
        }
    }

    fun addMenuItem(name: String, categoryName: String, price: Double, isAvailable: Boolean = true) {
        viewModelScope.launch {
            var category = categories.value.find { it.name.equals(categoryName, ignoreCase = true) }
            if (category == null) {
                category = posRepository.saveCategory(categoryName)
            }
            if (category != null) {
                posRepository.saveMenuItem(name, category.id, price, isAvailable)
            }
        }
    }

    fun deleteMenuItem(itemId: String) {
        viewModelScope.launch {
            posRepository.deleteMenuItem(itemId)
        }
    }
}

